module.exports = __webpack_public_path__ + "static/media/change-password-ico.ddaff590.svg";